// extracted by mini-css-extract-plugin
module.exports = {"message":"AdditionalMessage_message__NnWx6","newTypography":"AdditionalMessage_newTypography__JaC2V"};